import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * a default button
 */
const Button = ({ className, isSquare, onClick, children, ...rest }) => {
 
  const classNames = classnames('button', className, {
    'button--isSquare': isSquare
  });
 
  return (
    <button
      type="button"
      className={classNames}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    isSquare: PropTypes.bool
};

export default Button;